import { render, staticRenderFns } from "./InviteDetailGrid.vue?vue&type=template&id=0ef51ab0"
import script from "./InviteDetailGrid.vue?vue&type=script&lang=js"
export * from "./InviteDetailGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports